import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.482 5.816A5.6 5.6 0 0 1 17.007 3.5c3.161 0 5.474 2.618 5.474 5.727 0 3.1-1.958 5.834-3.98 7.848-2.045 2.04-4.306 3.493-5.207 4.037a1.57 1.57 0 0 1-1.625 0c-.9-.544-3.162-1.998-5.208-4.039-2.02-2.015-3.98-4.75-3.98-7.85 0-3.11 2.315-5.723 5.475-5.723 1.86 0 3.502.914 4.526 2.316m4.525-.683c-1.716 0-3.193 1.109-3.757 2.683a.816.816 0 0 1-1.537 0c-.564-1.574-2.04-2.683-3.757-2.683-2.16 0-3.842 1.78-3.842 4.09 0 2.43 1.562 4.762 3.5 6.694 1.89 1.885 3.997 3.25 4.868 3.779.871-.529 2.978-1.893 4.867-3.777 1.938-1.931 3.5-4.263 3.5-6.692 0-2.311-1.683-4.094-3.842-4.094",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }